<div *ngIf="bannerType !== BannerType.None" class="data-usage-banner {{ bannerType }}">
  <capra-banner class="banner-container">
    <span capra-banner-content class="content-wrapper">
      <capra-status-icon status="{{ bannerIcon }}"></capra-status-icon>
      <p class="warning-message">{{ bannerText }}</p>
      <mode-calendly-popup-button>
        <p class="warning-message calendly-link">
          Talk to {{ appName === 'Analyst Studio' ? 'an' : 'a' }} {{ appName }} Representative to see what you can do
          next
        </p>
      </mode-calendly-popup-button>
    </span>
  </capra-banner>
</div>
